/* eslint-disable */
export const Tooltip = {
  unbind(el){
    let childTooltip = document.getElementById(el.getAttribute('data-tooltip'));
    if(childTooltip){
      document.body.removeChild(childTooltip);
      el.removeAttribute('data-tooltip');
    }
  },
  bind(el, binding, vnode) {
    if(binding.value === undefined || binding.value === '') return;
    // Create tooltip body
    let tooltipContainer = document.createElement('span');
    tooltipContainer.classList.add('tooltip');
    tooltipContainer.innerText = binding.value;
    
    // Add identifier on element and tooltip
    let randomizer = function(name){
      let randomVal = name + (Math.floor(Math.random() * Math.floor(10000)));
      if( document.getElementById(randomVal) ){
        randomizer();
      }else{
        return randomVal;
      }
    };
    let tooltipVal = randomizer('f-app');
    tooltipContainer.setAttribute("id", tooltipVal);
    el.setAttribute("data-tooltip", tooltipVal);

    document.body.appendChild(tooltipContainer);
    if((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPod/i)) || (navigator.userAgent.match(/iPad/i))) {
      el.addEventListener('click', function(e){});
    }
    el.addEventListener('mouseenter', function(){
      tooltipContainer.classList.add('visible');
      setTimeout(function(){
        tooltipContainer.classList.add('showed');
      }, 10);

      // position tooltip
      var rect = el.getBoundingClientRect();
      
      // Element where tooltip is attached
      var parentTop = rect.top + window.pageYOffset;
      var parentLeft = rect.left;
      var parentWidth = rect.width;
      var parentHeight = rect.height;

      // Tooltip height and width
      var rectTooltip = tooltipContainer.getBoundingClientRect();
      var tHeight = rectTooltip.height;
      var tWidth = rectTooltip.width;
      
      // Window dimensions
      var windowH = window.innerHeight;
      var windowW = window.innerWidth;
      
      // CHECK IF IT FITS TO THE BOTTOM
      if( windowH > rect.top + tHeight + parentHeight + 20 ){
        // Place at bottom
        tooltipContainer.style.top = (parentTop + parentHeight + 20) + 'px';
        tooltipContainer.classList.add('carrot-t');
      }else{
        // Place at top
        tooltipContainer.style.top = (parentTop - 20 - tHeight) + 'px';
        tooltipContainer.classList.add('carrot-b');
      }
     
      // Check if it fits to sides left / right
      var posLeft = (parentLeft - (tWidth/2) + (parentWidth / 2));
      if( posLeft > 0 && (posLeft + tWidth) < windowW ){
        // Enough room left and right
        tooltipContainer.style.left = posLeft + 'px';
        tooltipContainer.classList.add('carrot-c');
      }else if( 0 > parentLeft - (tWidth / 2) && windowW > parentLeft + (tWidth / 2) ){
        // Left out
        tooltipContainer.style.left = (parentLeft + parentWidth / 2 - 20) + 'px';
        tooltipContainer.classList.add('carrot-l');
      }else if( 0 < parentLeft - (tWidth / 2) && windowW < parentLeft + tWidth ){
        // Right out
        tooltipContainer.style.left = (parentLeft - tWidth + parentWidth / 2 + 20) + 'px';
        tooltipContainer.classList.add('carrot-r');
      }

    });
    el.addEventListener('mouseleave', function(){
      tooltipContainer.classList.remove('showed');
      setTimeout(function(){
        tooltipContainer.classList.remove('visible');
        tooltipContainer.classList.remove('carrot-t');
        tooltipContainer.classList.remove('carrot-b');
        tooltipContainer.classList.remove('carrot-c');
        tooltipContainer.classList.remove('carrot-l');
        tooltipContainer.classList.remove('carrot-r');
        tooltipContainer.style.left = "auto";
        tooltipContainer.style.top = "auto";
      }, 100);
    });
  },
};



// WEBPACK FOOTER //
// ./src/directives/tooltip/index.js